import {writable} from 'svelte/store';
import {api} from './../lib/api'

export default userStore();

function userStore(){
    const store = writable(null,async set => {
        await getUser(set);
    });

    store.fetch = () => getUser(store.set);

    return store;
}

async function getUser(set){
    set(null);
    set(await api.get('/user/authed'));
}